import React from 'react';

interface ColdStartModalProps {
  isVisible: boolean;
}

const ColdStartModal: React.FC<ColdStartModalProps> = ({ isVisible }) => {
  if (!isVisible) return null;

  return (
    <div style={styles.overlayStyle}>
      <div style={styles.modalStyle}>
        {/* Animated spinner */}
        <div style={styles.spinnerContainerStyle}>
          <div style={styles.spinnerBackgroundStyle}></div>
          <div style={styles.spinnerStyle}></div>
        </div>

        {/* Message */}
        <h2 style={styles.titleStyle}>Waking Up Database</h2>
        <p style={styles.messageStyle}>
          The database is starting up from sleep mode.
        </p>
        <p style={styles.subtextStyle}>
          This typically takes 30-60 seconds, but may take up to 3 minutes in
          rare cases. Thank you for your patience!
        </p>

        {/* Progress indicator */}
        <div style={styles.progressContainerStyle}>
          <div style={styles.dotsContainerStyle}>
            <div style={{ ...styles.dotStyle, animationDelay: '0ms' }}></div>
            <div style={{ ...styles.dotStyle, animationDelay: '150ms' }}></div>
            <div style={{ ...styles.dotStyle, animationDelay: '300ms' }}></div>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  overlayStyle: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 9999,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    backdropFilter: 'blur(4px)',
  } as React.CSSProperties,
  modalStyle: {
    backgroundColor: 'white',
    borderRadius: '0.5rem',
    boxShadow:
      '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    padding: '2rem',
    maxWidth: '28rem',
    margin: '0 1rem',
    textAlign: 'center',
  } as React.CSSProperties,
  spinnerContainerStyle: {
    marginBottom: '1.5rem',
    display: 'flex',
    justifyContent: 'center',
  } as React.CSSProperties,
  spinnerBackgroundStyle: {
    position: 'absolute',
    width: '4rem',
    height: '4rem',
    border: '4px solid #BFDBFE',
    borderRadius: '50%',
  } as React.CSSProperties,
  spinnerStyle: {
    position: 'relative',
    width: '4rem',
    height: '4rem',
    border: '4px solid #2563EB',
    borderRadius: '50%',
    borderTopColor: 'transparent',
    animation: 'spin 1s linear infinite',
  } as React.CSSProperties,
  titleStyle: {
    fontSize: '1.5rem',
    fontWeight: 700,
    color: '#1F2937',
    marginBottom: '0.75rem',
    marginTop: 0,
  } as React.CSSProperties,
  messageStyle: {
    color: '#4B5563',
    marginBottom: '0.5rem',
    fontSize: '1rem',
    marginTop: 0,
  } as React.CSSProperties,
  subtextStyle: {
    color: '#6B7280',
    fontSize: '0.875rem',
    marginTop: 0,
    marginBottom: 0,
  } as React.CSSProperties,
  progressContainerStyle: {
    marginTop: '1.5rem',
  } as React.CSSProperties,
  dotsContainerStyle: {
    display: 'flex',
    justifyContent: 'center',
    gap: '0.5rem',
  } as React.CSSProperties,
  dotStyle: {
    width: '0.5rem',
    height: '0.5rem',
    backgroundColor: '#2563EB',
    borderRadius: '50%',
    animation: 'bounce 1s infinite',
  } as React.CSSProperties,
};

// Add keyframe animations via style tag
const styleSheet = document.createElement('style');
styleSheet.textContent = `
  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
  @keyframes bounce {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-0.5rem); }
  }
`;
if (!document.head.querySelector('[data-cold-start-animations]')) {
  styleSheet.setAttribute('data-cold-start-animations', 'true');
  document.head.appendChild(styleSheet);
}

export default ColdStartModal;
